export default __webpack_public_path__ + "static/paulChapman-b63a4f1ef3102b2688eb7a368d312c72.jpeg";